import { capitalize } from '@material-ui/core';
export function sanitizePhoneNumber(formattedPhoneNumber) {
    /*
    (###) ###-#### → ##########
    */
    if (typeof formattedPhoneNumber !== 'string') {
        return '';
    }
    var digitsRegex = /\d+/g;
    var matches = String(formattedPhoneNumber).match(digitsRegex);
    if (matches) {
        return matches.join('');
    }
    else {
        return '';
    }
}
/**
 * format a US phone number
 * @param {number | string} raw 10 or 12 digit, handles +1 at the begining of a number
 * @returns string formattting string
 */
export function formatRawPhoneNumber(raw) {
    /*
    ########## → (###) ###-####
    */
    if (typeof raw === 'number' || typeof raw === 'string') {
        var rawString = String(raw);
        if (rawString.length < 10) {
            // an incomplete phone number
            return rawString;
        }
        // allow for +1 phone numbers
        if (rawString.length === 12) {
            rawString = rawString.substring(2);
        }
        var areaCode = rawString.slice(0, 3);
        var prefix = rawString.slice(3, 6);
        var lineNumber = rawString.slice(6, 10);
        return "(" + areaCode + ") " + prefix + "-" + lineNumber;
    }
    else {
        return '';
    }
}
export function formatPatientPhoneNumber(raw, phoneType) {
    return formatRawPhoneNumber(raw) + " \u2022 " + capitalize(phoneType.toLowerCase());
}
export default {
    sanitizePhoneNumber: sanitizePhoneNumber,
    formatRawPhoneNumber: formatRawPhoneNumber,
    formatPatientPhoneNumber: formatPatientPhoneNumber,
};
